module.exports = __webpack_public_path__ + "media/images/icons/outlined/code-sandbox-f49999498f36aa94645923768c510494.svg";